import Image from 'next/image';

type BrandLogoProps = {
	className?: string;
	priority?: boolean;
};

export function BrandLogo({ className, priority }: BrandLogoProps): JSX.Element {
	return (
		<>
			<Image
				src="/images/logo/PNG/Horizontal/JCW_Logo_Updated_2026-05.png"
				alt="JovianCloudWorks Logo"
				width={180}
				height={77}
				className={`block dark:hidden ${className ?? ''}`}
				priority={priority}
			/>
			<Image
				src="/images/logo/PNG/Horizontal/JCW_Logo_Updated_2026-06.png"
				alt="JovianCloudWorks Logo"
				width={180}
				height={77}
				className={`hidden dark:block ${className ?? ''}`}
				priority={priority}
			/>
		</>
	);
}
